// 培训讲师
export const teacherList = `/api/unoauth/user/trainer/list`;

export const teacherDetail = `/api/oauth/user/trainer/getInfo/`;
